import {createI18n} from "vue-i18n"

const loadLocaleMessages = async (locale: string) => {
  try {
    const messages = await import(`./locales/${locale}.json`)
    return messages.default
  } catch (error) {
    console.error(`Failed to load locale messages for ${locale}:`, error)
    return {}
  }
}

const formatsCache: Record<string, any> = {}

const loadFormats = async (locale: string) => {
  if (formatsCache[locale]) {
    return formatsCache[locale]
  }

  try {
    const formats = await import(`./formats/${locale}.ts`)
    formatsCache[locale] = formats.default
    return formats.default
  } catch (error) {
    console.error(`Failed to load formats for ${locale}:`, error)
    return {numberFormats: {}, datetimeFormats: {}}
  }
}

const customRule: (choice: number, choicesLength: number) => number = (choice, choicesLength) => {
  if (choice === 0) {
    return 0
  }

  const teen = choice > 10 && choice < 20
  const endsWithOne = choice % 10 === 1

  if (choicesLength < 4) {
    return (!teen && endsWithOne) ? 1 : 2
  }
  if (!teen && endsWithOne) {
    return 1
  }
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2
  }

  return (choicesLength < 4) ? 2 : 3
}

const i18n = createI18n({
  legacy: false,
  locale: "uk",
  fallbackLocale: "uk",
  messages: {},
  numberFormats: {},
  datetimeFormats: {},
  globalInjection: true,
  useScope: "global",
  pluralRules: {
    uk: customRule ,
  },
})
const loadAndSetLocale = async (locale: string) => {
  const messages = await loadLocaleMessages(locale)
  const formats = await loadFormats(locale)
  i18n.global.setLocaleMessage(locale, messages)
  i18n.global.setNumberFormat(locale, formats.numberFormats)
  i18n.global.setDateTimeFormat(locale, formats.datetimeFormats)
  i18n.global.locale.value = locale
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  // document.querySelector('html').setAttribute('lang', locale)
}
export {i18n, loadAndSetLocale}
